import React from 'react'
import { Link } from 'react-router-dom'

import {FiArrowRight, FiHeart, FiMessageCircle} from '../assets/icons/vander'

import client from '../assets/images/client/05.jpg'

export default function BlogAbout() {
  return (
    <>
        <div className="mt-4">
            <div className="mb-3">
                <span className="badge bg-primary m-x-2">Fashion</span>
                <span className="badge bg-primary m-x-2">Travel</span>
                <span className="badge bg-primary m-x-2">Personal</span>
            </div>
            <p className="text-muted">If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page (layout or type area). For this reason, dummy text usually consists of a more or less random series of words or syllables. This prevents repetitive patterns from impairing the overall visual impression and facilitates the comparison of different typefaces.</p>
        
            <ul className="list-unstyled text-muted">
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Digital Marketing Solutions for Tomorrow</li>
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Our Talented & Experienced Marketing Agency</li>
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Create your own skin to match your brand</li>
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Digital Marketing Solutions for Tomorrow</li>
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Our Talented & Experienced Marketing Agency</li>
                <li className="mt-2"><FiArrowRight className="fea icon-sm me-2"/>Create your own skin to match your brand</li>
            </ul>
            
            <p className="text-muted mb-0">In the 1960s, the text suddenly became known beyond the professional circle of typesetters and layout designers when it was used for Letraset sheets (adhesive letters on transparent film, popular until the 1980s) Versions of the text were subsequently included in DTP programmes such as PageMaker etc.</p>
        
            <blockquote className="blockquote bg-light block-style-one p-4 mt-4 mb-0 position-relative rounded shadow">
                <p className="fst-italic mb-3 text-muted fs-5">“ Many of life's failures are people who did not realize how close they were to success when they gave up. ”</p>
                <h6 className="mb-0">- Thomas A. Edison</h6>

                <i className="mdi mdi-format-quote-open"></i>
            </blockquote>
        </div>
        
        <div className="d-flex align-items-center justify-content-between border-top border-bottom mt-4 p-4">
            <ul className="list-unstyled post-meta mb-0">
                <li className="list-inline-item me-2 mb-0"><Link to="#" className="text-muted like"><FiHeart className="me-1 align-middle"/>33</Link></li>
                <li className="list-inline-item"><Link to="#" className="text-muted comments"><FiMessageCircle className="me-1 align-middle"/>08</Link></li>
            </ul>

            <span className="text-muted">By <Link to="#" className="text-primary fs-6">Leaping Clark</Link></span>
        </div>

        <div className="py-4">
            <h4 className="heading-title mb-0">Author</h4>

            <div className="d-md-flex align-items-center mt-4 pt-2">
                <img src={client} className="avatar avatar-medium rounded-pill" alt=""/>

                <div className="ms-md-3 mt-3 mt-md-0">
                    <h5 className="mb-0">Leaping Clark</h5>

                    <p className="text-muted my-2">Obviously I'm a Content writer. Web Developer with over 3 years of experience. Experienced with all stages of the development cycle for dynamic web projects.</p>
                    
                    <Link to="#" className="text-primary fs-6">View Profile<FiArrowRight className=""/></Link>
                </div>
            </div>
        </div> 
    </>
  )
}
